import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {OwlModule} from 'angular-owl-carousel';
import {LazyLoadImageModule} from 'ng-lazyload-image';

import {SharedModule} from '../../shared/shared.module';
import {EditorialComponent} from './index/editorial.component';

@NgModule({
    declarations: [
        EditorialComponent
    ],

    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        OwlModule,
        SharedModule,
        LazyLoadImageModule
    ]
})

export class EditorialModule {
}
